import { render } from "./DragCard3.vue?vue&type=template&id=28d7e68f&scoped=true&ts=true"
import script from "./DragCard3.vue?vue&type=script&lang=ts"
export * from "./DragCard3.vue?vue&type=script&lang=ts"

import "./DragCard3.vue?vue&type=style&index=0&id=28d7e68f&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d7e68f"]])

export default __exports__